import {AsyncInlineError, streamify, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {UserErrorsFactory} from '../../user/Errors/factory.js'
import UserServicesFactory from '../../user/Services/factory.js'
import {HttpNewsBookmarksRepository} from '../Repositories/HttpNewsBookmarksRepository.js'

@streamify('execute')
class DeleteNewsBookmarksUseCase extends UseCase {
  #getCurrentUserService
  #repository
  #userNotLoggedInError

  static create({config}) {
    return new DeleteNewsBookmarksUseCase({
      getCurrentUserService: UserServicesFactory.getCurrentUserService({config}),
      repository: HttpNewsBookmarksRepository.create({config}),
      userNotLoggedInError: UserErrorsFactory.userNotLoggedInUserError
    })
  }

  constructor({getCurrentUserService, repository, userNotLoggedInError}) {
    super()
    this.#getCurrentUserService = getCurrentUserService
    this.#repository = repository
    this.#userNotLoggedInError = userNotLoggedInError
  }

  @tracer({metric: 'DeleteNewsBookmarksUseCase#execute'})
  @AsyncInlineError()
  async execute({articleId} = {}) {
    const userEntity = await this.#getCurrentUserService.execute()

    if (!userEntity)
      return Promise.reject(
        this.#userNotLoggedInError({message: '[DeleteNewsBookmarksUseCase#execute] User is not logged in'})
      )

    const userId = userEntity.getId()
    const [error] = await this.#repository.delete({userId, articleId})

    if (error) return Promise.reject(error)

    return true
  }
}

export const factory = DeleteNewsBookmarksUseCase.create
